const slug = 'b-slider';

export const dashboardInfo = (info) => {
    const { version, isPremium, hasPro } = info;

    const proSuffix = isPremium ? 'Pro' : '';

    return {
        name: `bSlider ${proSuffix}`,
        displayName: `bSlider ${proSuffix}  – Responsive Image Slider`,
        description: 'bSlider is Gutenberg Block an image and text slider. Using this slider you can create your slider very easily and in a short time. bSlider is the best match for you and your customers. You can use any theme.',
        slug,
        logo: `https://ps.w.org/${slug}/assets/icon-128x128.png`,
        // banner: `https://b-slider.bplugins.com/wp-content/uploads/2025/09/welcome-2.png`,
        video: 'https://www.youtube.com/watch?v=qgSBHjGdegg',
        isYoutube: true,
        version,
        isPremium,
        hasPro,
        pages: {
            org: `https://wordpress.org/plugins/${slug}/`,
            landing: `https://bplugins.com/products/${slug}/`,
            docs: `https://bplugins.com/docs/${slug}/`,
            pricing: `https://bplugins.com/products/${slug}/pricing`,
        },
        freemius: {
            product_id: 19318,
            plan_id: 32001,
            public_key: 'pk_b24b0b3f21a9dbfaff418c0c40fc1'
        }
    }
}

export const changelogs = [

    {
        version: '2.0.2 – 23 Aug, 2025',
        list: [
            'Resolved the conflict between Modula Image Gallery and bSlider.',
        ]
    },


    {
        version: '2.0.1 – 12 Aug, 2025',
        list: [
            'Resolved all security vulnerabilities identified by Wordfence;',
        ]
    },
    {
        version: '2.0.0 – 9 Aug, 2025',
        list: [
            'Fixed missing authorization check that allowed authenticated users (admin) to install arbitrary plugins;',
        ]
    },
    {
        version: '1.1.29 – 23 July, 2025',
        list: [
            'Resolved dashboard target element issue;',
        ]
    },
    {
        version: '1.1.28 – 8 July, 2025',
        list: [
            'Added four source types: Image, Posts, WooCommerce, and Video.',
            'Added four layout types: Slider, Carousel, Grid, and Thumbnails'
        ]
    }
];

export const demoInfo = {
    title: 'Live Overview',
    description: 'Click on any section to view it live',
    allInOneLabel: 'See All Demos',
    allInOneLink: 'https://bplugins.com/products/b-slider/#demos',
    demos: [
        {
            icon: '',
            title: 'Posts Default Layout Fade Effect',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-default-layout-fade-effect/'
        },
        {
            icon: '',
            title: 'Woo Thumbnails Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-thumbnails-layout/'
        },
        {
            icon: '',
            title: 'Image Indicators',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/image-indicators/'
        },
        {
            icon: '',
            title: 'Posts Carousel Grid Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-carosel-layout-grid-style/'
        },
        {
            icon: '',
            title: 'Posts Carousel Ticker Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/post-carousel-layout-ticker-style/'
        },
        {
            icon: '',
            title: 'Posts Carousel Center Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-carosel-layout-center-style/'
        },
        {
            icon: '',
            title: 'Post Carousel 3D Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-carousel-layout-3d-style/'
        },
        {
            icon: '',
            title: 'Video Carousel 3D Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-carousel-layout-3d-style/'
        },
        {
            icon: '',
            title: 'Video Carousel Ticker Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-carousel-layout-ticker-style/'
        },
        {
            icon: '',
            title: 'Video Carousel Center Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-carousel-layout-center-style/'
        },
        {
            icon: '',
            title: ' Woo Carousel 3D Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-carousel-layout-3d-style/'
        },
        {
            icon: '',
            title: 'Woo Carousel Grid Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-carousel-layout-grid-style/'
        },
        {
            icon: '',
            title: 'Woo Carousel Ticker Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-carousel-layout-ticker-style/'
        },
        {
            icon: '',
            title: 'Woo Carousel Center Style',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-carousel-layout-center-style/'
        },

        {
            icon: '',
            title: 'Video Default Layout Fade Effect',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-default-layout-fade-effect/'
        },
        {
            icon: '',
            title: 'Video Default Layout Image Indicators',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-default-layout-image-indicators/'
        },
        {
            icon: '',
            title: 'Video Thumbnails Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-thumbnails-layout/'
        },
        {
            icon: '',
            title: 'Video Grid Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-grid-layout/'
        },
        {
            icon: '',
            title: 'Video Carousel Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-carousel-layout/'
        },
        {
            icon: '',
            title: 'Video Default Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/video-default-layout/'
        },
        {
            icon: '',
            title: 'Woo Default Layout Fade Effect',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-default-layout-fade-effect/'
        },
        {
            icon: '',
            title: 'Woo Default Layout Image Indicators',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-default-layout-image-indicators/'
        },

        {
            icon: '',
            title: 'Woo Grid Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-grid-layout/'
        },
        {
            icon: '',
            title: 'Woo Carousel Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-carousel-layout/'
        },
        {
            icon: '',
            title: 'Woo Default Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/woo-default-layout/'
        },
        {
            icon: '',
            title: 'Posts Default Layout Fade Effect',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-default-layout-image-indicators/'
        },
        {
            icon: '',
            title: 'Posts Thumbnails Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-thumbnails-layout/'
        },
        {
            icon: '',
            title: 'Posts Grid Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-grid-layout/'
        },
        {
            icon: '',
            title: 'Posts Carousel Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-carousel-layout/'
        },
        {
            icon: '',
            title: 'Posts Default Layout',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/posts-default-layout/'
        },
        {
            icon: '',
            title: 'Full Width Slider',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/full-width/'
        },
        {
            icon: '',
            title: 'Vertically Image Indicators Left',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/vertical-image-indicators-left/'
        },
        {
            icon: '',
            title: 'Vertically Image Indicators Right',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/vertical-image-indicators-right/'
        },
        {
            icon: '',
            title: 'Dot Indicators',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/dot-indicators/'
        },
        {
            icon: '',
            title: 'Mouse Drag Slide',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/mouse-drag-slide/'
        },
        {
            icon: '',
            title: 'Arrow Follow Mouse',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/arrow-follow-mouse/'
        },
        {
            icon: '',
            title: 'Slide on Mouse Wheel',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/slide-on-mouse-wheel/'
        },
        {
            icon: '',
            title: 'Vertically Slide',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/vertical-slide/'
        },
        {
            icon: '',
            title: 'Default Content',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/default-content/'
        },
        {
            icon: '',
            title: 'Animation Slider',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/animation-slider/'
        },
        {
            icon: '',
            title: 'Content Slider',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/content-slider/'
        },
        {
            icon: '',
            title: 'Image Slider',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/image-slider/'
        },
        {
            icon: '',
            title: 'Customize Slider',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/customize/'
        },
        {
            icon: '',
            title: 'Default Slider',
            description: '',
            category: '',
            type: 'iframe',
            url: 'https://b-slider.bplugins.com/demo/default/'
        },
    ]
}

export const pricingInfo = {
    cycles: [
        {
            cycle: 'lifetime',
            label: 'Lifetime',
            isDefault: false
        }
    ],
    plans: [
        {
            name: 'Single Site',
            quantity: 1,
            prices: {
                lifetime: '29'
            },
            pricePrefix: '',
            priceSuffix: '',
            isFeatured: false,
            note: ''
        },
        {
            name: '3 Sites',
            quantity: 3,
            prices: {
                lifetime: '79'
            },
            pricePrefix: '',
            priceSuffix: '',
            isFeatured: true,
            note: ''
        },
        {
            name: 'Unlimited Sites',
            quantity: 'null',
            prices: {
                lifetime: '199'
            },
            pricePrefix: '',
            priceSuffix: '',
            isFeatured: false,
            note: ''
        }
    ],
    features: [
        'Shortcode Support: Place sliders anywhere on your site using shortcodes.',
        'Advanced Carousel Styles: Create unique carousels with ticker, grid, and 3D effects.',
        'Creative Effects: Use coverflow and card-style transitions for modern visual appeal.',
        'Buttons in Content: Add clickable buttons inside slides for CTAs and product links.',
        'Advanced Animations: Control timing, delay, and duration for text and button animations.',
        'Custom Image Indicators: Replace default indicators with images for a more branded look.',
        'Multiple Arrow Icons: Select from different arrow styles to fit your design.',
        'Flexible Content Positioning: Place content anywhere within each slide for more control.',
        'Drag-and-Drop Reordering: Organize slides easily by dragging and dropping items.',
        'Mouse Controls: Navigate with the mouse wheel, dragging, or grab the cursor for better usability.',
        'Arrow Follow Mouse: Enable arrows that follow mouse movement for dynamic navigation.',
        'Responsive Slider Height: Adjust slider height per device for better responsiveness.',
        'Advanced Post Controls: Set posts per page, change order, exclude/include posts, or skip current post.',
        'WooCommerce Advanced Options: Apply the same filters and display controls to products.',
        'Full Video Controls: Unlock rewind, fast forward, progress bar, time display, mute, volume, PIP, AirPlay, download, and full screen.',
        'Grid Pagination: Add pagination with options for load more or numbered pages, aligned left, right, or center.',
        'Pagination Styling: Customize buttons with typography, colors, padding, and borders.',
        'Enhanced Thumbnails: Control navigation arrows, overlays, cursor options, and direction for thumbnails.',
        'Multiple Layouts: Switch between slider, carousel, grid, or thumbnails for flexible presentations.',


    ],
    button: {
        label: 'Buy Now ➜'
    },
    featured: {
        text: 'Best Value'
    }
}

export const featureCompareInfo = {
    title: 'Features',
    plans: [
        {
            id: 'ztbk4ex2fyi',
            name: 'Free Plan',
            color: '#485781'
        },
        {
            id: 'lhmjqhkeyi',
            name: `<span style='color: #485781;'>Pro Start from </span><span style='font-size: 1.3em;'>$29 Only</span>`,
            color: '#146EF5'
        }
    ],
    features: [
        {
            label: 'Unlimited Slides: Create as many slides as you need for products, portfolios, or content highlights.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Easy Slide Management: Quickly duplicate or remove slides for faster editing and organization.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Customizable Content Styles: Style titles and descriptions with flexible typography and design controls.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Navigation Buttons: Add left and right arrows with customizable size, color, and border radius.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Slide Indicators: Choose from different styles and positions to help users navigate easily.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Autoplay Controls: Turn autoplay on or off, set custom duration, and adjust timing per slide.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Hover Pause: Pause the slider when users hover, improving interactivity and focus.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Overlay Colors: Add color overlays on slides for better contrast and text visibility.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Slide Animations: Apply smooth transitions like fade, slide, or flip to catch attention.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Content Positioning: Align text and elements at the default or middle area of the slide.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Arrow Styling: Customize arrow size, height, width, border, and color to match your theme.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Carousel Layout: Create looping, autoplay carousels with horizontal or vertical direction.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Grid Layout: Display sliders in responsive grids with adjustable column and row gaps.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Thumbnails Layout: Add thumbnail navigation with overlay, autoplay, and border options.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Post Slider Options: Query posts by category or tag, show excerpts, and limit content length.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'WooCommerce Slider: Highlight products with content length and excerpt display controls.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Video Slider Options: Enable popup playback with repeat, mute, autoplay, reset, or hide controls.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Basic Video Controls: Show a large play button and restart option for easier interaction.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Gutenberg Block: Add sliders directly in the block editor with full customization.',
            plans: ['ztbk4ex2fyi', 'lhmjqhkeyi']
        },
        {
            label: 'Shortcode Support: Place sliders anywhere on your site using shortcodes.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Advanced Carousel Styles: Create unique carousels with ticker, grid, and 3D effects.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Creative Effects: Use coverflow and card-style transitions for modern visual appeal.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Buttons in Content: Add clickable buttons inside slides for CTAs and product links.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Advanced Animations: Control timing, delay, and duration for text and button animations.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Custom Image Indicators: Replace default indicators with images for a more branded look.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Multiple Arrow Icons: Select from different arrow styles to fit your design.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Flexible Content Positioning: Place content anywhere within each slide for more control.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Drag-and-Drop Reordering: Organize slides easily by dragging and dropping items.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Mouse Controls: Navigate with the mouse wheel, dragging, or grab the cursor for better usability.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Arrow Follow Mouse: Enable arrows that follow mouse movement for dynamic navigation.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Responsive Slider Height: Adjust slider height per device for better responsiveness.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Advanced Post Controls: Set posts per page, change order, exclude/include posts, or skip current post.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'WooCommerce Advanced Options: Apply the same filters and display controls to products.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Full Video Controls: Unlock rewind, fast forward, progress bar, time display, mute, volume, PIP, AirPlay, download, and full screen.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Grid Pagination: Add pagination with options for load more or numbered pages, aligned left, right, or center.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Pagination Styling: Customize buttons with typography, colors, padding, and borders.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Enhanced Thumbnails: Control navigation arrows, overlays, cursor options, and direction for thumbnails.',
            plans: ['lhmjqhkeyi']
        },
        {
            label: 'Multiple Layouts: Switch between slider, carousel, grid, or thumbnails for flexible presentations.',
            plans: ['lhmjqhkeyi']
        },
    ]
}